
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/efdelta-recall-and-replacement",
      function () {
        return require("private-next-pages/efdelta-recall-and-replacement/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/efdelta-recall-and-replacement"])
      });
    }
  